import { useMemo } from 'react';

import IB_Preset, { Custom_Preset, Left_UnPaged_Presets } from '@bo-ibSheet/common';

export const USE_STATUS = [
  { key: '10', label: '사용' },
  { key: '20', label: '미사용' },
  { key: '30', label: '중지' },
  { key: '40', label: '삭제' },
];

export const useCoInfoOptions = (saveCoUserStatsSave) => {
  const statFormat = useMemo(() => {
    return USE_STATUS.reduce((prev, { key, label }) => {
      if (key === '30') prev[key] = `<div class='grid__round-item grid__round-item__red'>${label}</div>`;
      else if (key === '10') prev[key] = `<div class='grid__round-item grid__round-item__blue'>${label}</div>`;
      else if (key === '20') prev[key] = `<div class='grid__round-item grid__round-item__gray'>${label}</div>`;
      else prev[key] = `<div class='grid__round-item grid__round-item__darkgray'>${label}</div>`;
      return prev;
    }, {});
  }, []);

  const coMemberOptions = useMemo(
    () => ({
      Cfg: {
        AutoRowHeight: false,
        SearchMode: 0,
      },
      Def: {
        Row: {
          Height: 44,
          CanFormula: 1,
          CalcOrder: 'coUserStatusCanEdit,coUserNameCanEdit,cellphoneNumberCanEdit,CHKCanEdit',
        },
      },
      LeftCols: [
        {
          Header: { Value: '', Align: 'Center', Class: 'grid__checkbox' },
          Type: 'Bool',
          Name: 'CHK',
          Align: 'Center',
          Width: 60,
          MaxWidth: 60,
          CanSort: false,
          CanExport: false,
          ColMerge: false,
          NoChanged: true,
          CanEditFormula: ({ Row: { Added } }) => Added !== 1,
        },
        {
          Header: '번호',
          Type: 'Text',
          Width: 72,
          MaxWidth: 72,
          Align: 'Center',
          Name: 'SEQ',
          CanSort: false,
          CanEdit: false,
          CanExport: false,
        },
      ],
      Cols: [
        {
          Header: '사용상태',
          Type: 'Html',
          Name: 'coUserStatusDivisionCode',
          Key: 'CO_USER_STAT_DIVI_CD',
          MinWidth: 156,
          CanEdit: 0,
          Format: statFormat,
          DefaultValue: '20',
        },
        {
          Header: '중지/해제',
          Type: 'Radio',
          Name: 'coUserStatus',
          Key: 'CO_USER_STATUS',
          Enum: '|중지|해제',
          EnumKeys: '|Y|N',
          MinWidth: 275,
          CanEditFormula: ({ Row: { coUserStatusDivisionCode, Added } }) =>
            `${coUserStatusDivisionCode}` !== '40' && `${coUserStatusDivisionCode}` !== '20' && Added !== 1,
          OnChange: saveCoUserStatsSave,
        },
        {
          Header: 'ID',
          Type: 'Text',
          Name: 'coUserId',
          Key: 'CO_USER_ID',
          MinWidth: 200,
          CanEdit: 0,
          DefaultValue: '(자동생성ID)',
          Align: 'Center',
        },
        {
          Header: '사용자명',
          Type: 'Text',
          Name: 'coUserName',
          Align: 'Center',
          Key: 'CO_USER_NM',
          MinWidth: 200,
          CanEdit: 0,
        },
        {
          Header: '휴대전화번호',
          Type: 'Text',
          Name: 'cellphoneNumber',
          MinWidth: 112,
          Width: 200,
          Align: 'Center',
          ColMerge: false,
          CanSort: 0,
          CanEdit: 0,
        },
        {
          ...IB_Preset.YMD12HMS,
          Header: '최종접속일시',
          Name: 'finalLoginDate',
          Key: 'FINAL_LOGIN_DTIME ',
          MinWidth: 200,
          CanEdit: 0,
          EmptyValue: '',
        },
        {
          ...IB_Preset.YMD12HMS,
          Header: 'ID삭제일시',
          Name: 'idDeleteDate',
          Key: 'ID_DEL_DTIME',
          MinWidth: 200,
          CanEdit: 0,
          EmptyValue: '',
        },
      ],
    }),
    [statFormat]
  );

  const coMenuOptions = useMemo(
    () => ({
      Cfg: {
        AutoRowHeight: false,
        UseButton: 1,
      },
      Def: {
        Row: {
          Height: 44,
          CanFormula: 1,
        },
      },
      LeftCols: [...Left_UnPaged_Presets],
      Cols: [
        {
          ...Custom_Preset.UseYn,
          Header: '사용상태',
          MinWidth: 510,
          DefaultValue: 'N',
        },
        {
          Header: '메뉴명',
          Type: 'Text',
          Name: 'menuName',
          Key: 'MENU_NM',
          MinWidth: 924,
          CanEdit: 0,
        },
        {
          Header: 'menuNumber',
          Type: 'Text',
          Name: 'menuNumber',
          Key: 'MENU_NO',
          Hidden: true,
          Default: false,
          Size: 13,
          CanEdit: 0,
          RelWidth: true,
        },
      ],
    }),
    []
  );

  return { coMemberOptions, coMenuOptions };
};

export const filterList = [
  { name: '메뉴', code: 'B' },
  { name: '계정', code: 'C' },
];
